import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/api-service/api.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { HelpersService } from '../../../shared/helpers/helpers.service';
import { FormGroup , FormControl, ReactiveFormsModule, Validators, NgForm, FormArray, FormBuilder} from '@angular/forms';
import { matchOtherValidator } from '../../../shared/matchpass/matchpass';
import { Logging } from '../../../logging';
import { exists } from 'fs';
import { Permission } from '../../models/permission';
import { ComponentID, ActionType, PermissionHelper } from '../../../shared/helpers/permissionshelper';


declare var jquery:any;
declare var $ :any;
declare var App:any;
declare var FormSliderSwitcher:any;

@Component({
  selector: 'app-subusers-create',
  templateUrl: './subusers-create.component.html',
  styleUrls: ['./subusers-create.component.css']
})
export class SubusersCreateComponent implements OnInit {

  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService,private formBuilder: FormBuilder, private permhelper:PermissionHelper) { }

registerForm:  FormGroup;
showErrors:boolean = false;
loading: Boolean = false;
hasError: Boolean = false;
errorMessage: string ;
services: any[];
users: any[];


//Setting Active Route Var For The Side Nav to pick up
//activeRoute: string = "users.add";

  ngOnInit() {

    //this.permissions = this.helpers.PERMISSION_SERVICES;
   this.registerForm = new FormGroup({
      name: new FormControl('',Validators.required),
      fullaccess: new FormControl(false,Validators.required),
      email: new FormControl('',[ 
          Validators.required, 
          Validators.email,
        ]),
      phone: new FormControl('', Validators.required)
    });
    

    $(".default-select2").select2();


    //Fetch the available services
    this.api.get('/profiles/custauthitems')
    .subscribe(
      res_data => {
     //  Logging.log(res_data.data);

      //Collect the services if the request was successful and there was data retured.
      if(res_data.status == "SUCCESS" && res_data.data.length > 0 ){
       this.services = res_data.data;
       Logging.log(res_data.data);

      }

      
      }, error_message => {
       //  this.loading = false;
       //  this.hasError = true;
      this.helpers.flashDanger('An error has occured. Please refresh page or try again later');
      }
    );

  }

  hasPermission( pageid:string, action :string) : Boolean
  {
    return this.permhelper.hasPermission(pageid, action);
  }
 
  hasPermissionForOthers( pageid:string, action :string, userid:string) : Boolean
  {
    return this.permhelper.hasPermissionForOthers(pageid,action,userid);
  }

  Helpers(){
    return this.helpers;
  }

  userExist:boolean = false;

  checkEmail(email:string){

    if(this.registerForm.controls.email.valid){
      const body = {
        email: email,
      };
  
      this.api.post('/users/checkemail', body)
        .subscribe(
          res_data => {
          Logging.log(res_data);

          //Check if there was a success response with an existing user
          if(res_data.status == "SUCCESS"){
            //Check if there was an existing user returned
            if(res_data.data[0].status == true){
              this.userExist = true;
            }

          }

          }, error_message => {
            
            Logging.log('error');
          }
        );
    }
    
  }


  getIcon(perm:string)
  {
     var response : String ="fa fa-key";
    switch(perm)
    {
      case 'ADD':
        response = "fa fa-plus";
        break;
      case 'EDIT':
        response = "fa fa-edit";
        break;
      case 'VIEW':
        response = "fa fa-eye";
        break;
      case 'DELETE':
        response = "fa fa-trash-o";
        break;
      case 'APPROVE':
        response = "fa fa-check-circle";
        break;

    }
    return response;
  }

  clearUserCheck(){
    this.userExist = false;
  }

  onSubmit(form: NgForm){
    //Set loading to true to show loader
    this.loading = true;
    this.hasError = false;
    var requestpayload = {};

    if(this.registerForm.valid){
      //Logging.log(this.registerForm.value);
      const regfields = this.registerForm.value;

      //Construct the phone number
      //Remove 0 chr from the phone if present
      if(regfields.phone.startsWith('0')){
        regfields.phone = regfields.phone.replace("0","");
        regfields.phone = $('.selected-dial-code').text().replace("+", "") + regfields.phone;
      }

      

      const subuser = {
        email: regfields.email,
        iscompany : false,
        mobilenumber : regfields.phone,
        name : regfields.name
      };

      requestpayload['subuser'] = subuser;
      
      const permValues = JSON.parse(JSON.stringify(form.value));

      Logging.log(permValues);

      
      if(regfields.fullaccess === false  || regfields.fullaccess == "false")
      {
        var permid: string;
        var permobj : Permission = null;
        var limitedpermissions :Permission[] = [];
       
        for (let property in permValues)
        {
          if(property.indexOf('.') !== -1)
          {
            var prop_parts = property.split('.');
            if(permid != prop_parts[0] )
            {
              permid = prop_parts[0];
              if(permobj != null)
              {
                limitedpermissions.push(permobj);
              }

              permobj = new Permission();
              permobj.authitemid = permid;
              
            }
            
            if(prop_parts.length == 2)
            {
              permobj =  this.setPermissionFields(prop_parts[1],property,permValues,permobj);
            }
            else if(prop_parts.length == 3)
            {
              permobj.authitemname = prop_parts[2]; 
            }
          }
            
        }

        if(permobj!= null)
        {
          limitedpermissions.push(permobj);
        }

        requestpayload['limitedpermissions'] = limitedpermissions;
      }


      Logging.log(requestpayload);
     
      //Register the sub user
      this.api.post('/users/'+this.auth.getUserID() +'/subusers', requestpayload)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);
        this.helpers.flashSuccess('New user created successfully');
        //Take the user to the login page to manually login
        this.router.navigate(['/account']);
          
        }, error_message => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
        }
      );

    }else{
      //Set loading to true to show loader
      this.loading = false;
      this.hasError = false;

      this.showErrors = true;
      Logging.log('Has Errors', this.registerForm.value);
      const formValues = JSON.parse(JSON.stringify(form.value));

      // formValues.name = formValues.name.firstName + ' ' + formValues.name.lastName;
     // formValues.phone = $('.selected-dial-code').text().replace("+", "") + formValues.phone;

      Logging.log(formValues);
    }
  }

  setPermissionFields(part: string,property: any, permValues:any,permobj: any )
  {
    switch(part)
    {
      case 'ADD':
        permobj.canadd = (permValues[property] === true) ? true : false;
      break;
      case 'EDIT':
        permobj.canedit = (permValues[property] === true) ? true : false;
      break;
      case 'VIEW':
        permobj.canview = (permValues[property] === true) ? true : false;
      break;
      case 'DELETE':
        permobj.candelete = (permValues[property] === true) ? true : false;
      break;
      case 'APPROVE':
        permobj.canapprove = (permValues[property] === true) ? true : false;
      break;
    }

    return permobj;
  }

  clearErrors(){
    this.hasError = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/client/account/subusers-create/subusers-create.component.ts